import NotFound from 'common/NotFound';
import useFullPageLoader from 'common/UseFullPageLoader';
import useButtonLoader from 'hooks/useButtonLoader';
import React, { useEffect, useState } from 'react'
import { FaRegTrashAlt } from 'react-icons/fa';
import Pagination from 'react-js-pagination';
import { useSearchParams } from 'react-router-dom';
import findSerialNumber from 'utils/findSerialNumber';
import { GiMedicines } from "react-icons/gi";
import { addToCartQuantityApi, cartListApi, confirmOrder } from 'services/user';
import { userPlaceholder } from 'assets/icons';
import AddMedicines from './AddMedicines';
import { CustomModal } from 'components/modals/ModalBox';
import { IoIosAddCircleOutline, IoIosRemoveCircleOutline } from 'react-icons/io';
import { toastMessage } from 'utils/toastMessage';

const ApprovedMedicines = ({ userId }) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [loader, onShow, onHide] = useFullPageLoader();
    const activePage = +searchParams.get("page") || 1;
    const limit = +searchParams.get("limit") || 10;
    // const total = +searchParams.get("total") || 1;
    const [total, setTotal] = useState(0)
    const [medicineList, setMedicineList] = useState([])
    const [loading, setLoading] = useState(false)
    const [addModal, setAddModal] = useState(false)
    const [quantities, setQuantities] = useState({});
    const [imagePreview, setImagePreview] = useState({ url: '', modal: false });
    const [confirmButtonLoader, setConfirmButtonLoader] = useButtonLoader("Confirm Order");
    // console.log('medicineList', medicineList)
    // ----------initial-quantity------------------
    useEffect(() => {
        if (medicineList?.length > 0) {
            const initialQuantities = {};
            medicineList.forEach(item => {
                initialQuantities[item.variant?._id] = item?.quantity || 0;
            });
            setQuantities(initialQuantities);
        }
    }, [medicineList]);

    //-------------Handel-Pagination-------------
    const handlePageChange = (event) => {
        const newParams = new URLSearchParams(searchParams);
        newParams.set("page", event);
        setSearchParams(newParams);
    };
    //-------------image-preview-------------
    const handleImagePrev = (url) => {
        if (url) {
            setImagePreview({ url: url, modal: true })
        }
    };

    // ----------Listing-API-------------------
    const fetchApproveMedicineList = async () => {
        const query = {
            page: activePage,
            limit: limit,
            isAdmin: true,
        };
        onShow();
        try {
            const res = await cartListApi(userId, query);
            const { code, data } = res?.data;
            if (code === 200) {
                // const urlResponse = new URLSearchParams(searchParams);
                // urlResponse.set("total", total);
                // setSearchParams(urlResponse);
                // setTotal(data?.total || 0)
                setMedicineList(data?.products || []);
            }
        } catch (error) {
            console.log(error);
        } finally {
            onHide();
        }
    };

    useEffect(() => {
        fetchApproveMedicineList();
    }, [activePage]);


    // ------------add-to-cart-quantity-API--------------------
    const handleQuantityChange = async (type, productId, variantId) => {
        try {
            setLoading(true);
            const payload = {
                userId,
                productId,
                variantId,
                type,
            };
            const res = await addToCartQuantityApi(payload);
            const { code, message } = res?.data;

            if (code === 200) {
                if (type === "delete") {
                    const updatedList = medicineList.filter(
                        item => item?.variant?._id !== variantId
                    );
                    setMedicineList(updatedList);
                } else {
                    const updatedList = medicineList.map(item => {
                        if (item?.variant?._id == variantId) {
                            const current = item?.quantity || 1;
                            const newQuantity = type === "increase"
                                ? current + 1
                                : Math.max(1, current - 1);

                            return {
                                ...item,
                                quantity: newQuantity
                            };
                        }
                        return item;
                    });
                    setMedicineList(updatedList);
                }
            }
        } catch (error) {
            console.log("Error:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleConfirmOrder = async () => {
        try {
            setConfirmButtonLoader(true);
            const res = await confirmOrder({ userId });
            const { code, message } = res?.data;

            if (code === 200) {
                toastMessage(message || 'Order confirmed successfully', 'success', 'confirmOrder');
                fetchApproveMedicineList();
            }
        } catch (error) {
            console.log("Error:", error);
        } finally {
            setConfirmButtonLoader(false);
        }
    };


    return (
        <div className="user-management-container">
            <div className="page_title has_child mt-5">
                <div className="d-flex flex-column align-items-start">
                    <h3>Approved Medicines </h3>
                </div>
                <div className="tabContainer">
                    {medicineList.length > 0 && (
                        <button
                            className="button me-2"
                            type="button"
                            ref={confirmButtonLoader}
                            onClick={handleConfirmOrder}
                            disabled={loading}
                        >
                            Confirm Order
                        </button>
                    )}
                    <button
                        className="button"
                        type="button"
                        onClick={() => setAddModal(true)}
                    >
                        Add Medicines
                    </button>
                </div>
            </div>

            <div className="card">
                {loader}
                <div className="table-container">
                    <table className="table custom_table">
                        <thead>
                            <tr>
                                <th className="nowrap text-center">S.No</th>
                                <th className="nowrap text-center">Image</th>
                                <th className="nowrap text-center">Products </th>
                                <th className="nowrap text-center">Variant </th>
                                <th className="nowrap text-center">Type </th>
                                <th className="nowrap text-center">Action</th>
                            </tr>
                        </thead>

                        <tbody>
                            {medicineList.length > 0 ? (
                                medicineList?.map((data, index) => {
                                    return (
                                        <tr key={index}>
                                            <td className="nowrap text-center">
                                                {findSerialNumber(index, activePage, limit)}
                                            </td>

                                            <td className="nowrap text-center">
                                                <div className="td-img">
                                                    <img
                                                        src={data?.image?.[0] || userPlaceholder}
                                                        alt='icon'
                                                        onClick={() => handleImagePrev(data?.image?.[0])}
                                                    />
                                                </div>
                                            </td>
                                            <td className="nowrap text-center">
                                                {data?.name || "N/A"}
                                            </td>
                                            <td className="nowrap text-center">
                                                {data?.variant?.unitValue} - {data?.variant?.unit} ({data?.variant?.quantity})
                                            </td>
                                            <td className="nowrap text-center">
                                                {data?.itemType || "N/A"}
                                            </td>
                                            <td className="nowrap text-center">
                                                <div className="button-container">
                                                    <div className="add-to-cart-container">
                                                        <button
                                                            className="btn-control"
                                                            disabled={quantities[data.variant?._id] === 1}
                                                            onClick={() => handleQuantityChange('decrease', data.productId, data.variant._id)}
                                                        ><IoIosRemoveCircleOutline className='fs-2' />
                                                        </button>
                                                        <span className="quantity">
                                                            {quantities[data.variant?._id] || 1}
                                                        </span>
                                                        <button
                                                            className="btn-control"
                                                            onClick={() => handleQuantityChange('increase', data.productId, data.variant._id)}
                                                        >
                                                            <IoIosAddCircleOutline className='fs-2' />

                                                        </button>
                                                    </div>
                                                    <button
                                                        type="button"
                                                        onClick={() => handleQuantityChange('delete', data.productId, data.variant._id)}
                                                    >
                                                        <FaRegTrashAlt />
                                                    </button>
                                                </div>
                                            </td>

                                        </tr>
                                    );
                                })
                            ) : (
                                <NotFound
                                    cols={5}
                                    msg={"Approved Medicine data not found"}
                                    onHide={onHide}
                                    icon={<GiMedicines />}
                                />
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            {/* ----------Add-medicines------------- */}
            <AddMedicines
                show={addModal}
                close={() => setAddModal(false)}
                userId={userId}
                listing={fetchApproveMedicineList}
            />
            {/* ---------preview-image--------------- */}
            <CustomModal
                className={"sm image_preview_modal"}
                show={imagePreview?.modal}
                handleClose={() => { setImagePreview({ url: '', modal: false }) }}
            >
                <div className="image_preview">
                    <img
                        src={imagePreview?.url || userPlaceholder}
                        alt="user-profile-preview"
                    />
                </div>
            </CustomModal>
            {/* -----------pagination--------------- */}
            {total > limit && (
                <div className="pagination-wrapper">
                    <div className="Pagination">
                        <Pagination
                            activePage={activePage}
                            previousLabel={"previous"}
                            nextLabel={"next"}
                            itemsCountPerPage={limit}
                            totalItemsCount={total}
                            pageRangeDisplayed={5}
                            onChange={handlePageChange}
                            hideDisabled={true}
                        />
                    </div>
                </div>
            )}
        </div>
    )
}

export default ApprovedMedicines
